// extracted by mini-css-extract-plugin
export default {"footerButtons":"zaBT8gqycwtq4ZdU7I3d","failedBannerWrapper":"bcZQsDu_q4I8O0Eco6Qr","buttonsWrapper":"P839OqwdcCO1OJQ0SyfZ","rightButtons":"Lf4e0B0HLJWdHJzKC87w"};